import React, { createRef, useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { FormContext } from "../../context/form.context";
import { ServicesContext } from "../../context/services.context";
import { Form1, Form2, Form3, Loading } from "@supermegapay/common";
import FormWrapper from "../../components/UI/FormWrapper/FormWrapper";
import GreyBlock from "../../components/UI/GreyBlock/GreyBlock";
import inputStyle from "../../components/UI/FormInput/FormInput.module.scss";
import ReCAPTCHA from "react-google-recaptcha";
import cls from "./TransactionPage.module.scss";

const TransactionPage = () => {
  const [stage, setStage] = useState(1);
  const { id } = useParams();
  const { services } = useContext(ServicesContext);
  const { setFormData } = useContext(FormContext);
  const shop = "mtc.kg";
  const provider = "genesispay";
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = createRef();

  const item = services?.catalog.find((item) => item.id === Number(id));

  const defaultFormFields = item?.data.requiredFields.reduce(
    (object, value) => {
      return { ...object, [value.fieldId]: "" };
    },
    {},
  );

  const onChangeStage = () => {
    setStage((prev) => prev + 1);
  };

  const checkCaptchaAsync = async () => {
    await recaptchaRef.current.executeAsync();
  };

  const handleChangeCaptcha = (value) => {
    setCaptchaToken(value);
  };

  useEffect(() => {
    setFormData({ provider });
  }, [setFormData]);

  return (
    <>
      {!services ? (
        <Loading />
      ) : (
        <FormWrapper>
          <div className={cls.topLogo}>
            <img src={item.data.logo.url} alt="logo" />
            <h3>{item.data.name_ru}</h3>
          </div>
          {stage === 1 && (
            <Form1
              formContextProp={FormContext}
              item={item}
              defaultFormFields={defaultFormFields}
              onChangeStage={onChangeStage}
              inputStyle={inputStyle}
              shop={shop}
              captchaToken={captchaToken}
              checkCaptchaAsync={checkCaptchaAsync}
            />
          )}
          {stage === 2 && (
            <Form2
              formContextProp={FormContext}
              item={item}
              onChangeStage={onChangeStage}
            />
          )}
          {stage === 3 && (
            <>
              <Form3
                formContextProp={FormContext}
                inputStyle={inputStyle}
                captchaToken={captchaToken}
                checkCaptchaAsync={checkCaptchaAsync}
              />
              <GreyBlock />
            </>
          )}
          <ReCAPTCHA
            ref={recaptchaRef}
            size="invisible"
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={handleChangeCaptcha}
          />
        </FormWrapper>
      )}
    </>
  );
};

export default TransactionPage;
